import pluralize from 'pluralize';
import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { type CreditUsageStats } from '~/components/CreditUsageMeter/types';
import { getCreditUsageResetDisplay } from '~/components/CreditUsageMeter/utils';

export type CreditUsageMeterResetDateProps = Pick<ComponentProps<'div'>, 'className'> &
  Pick<CreditUsageStats, 'nextCycleStartAt'> & {
    label?: string;
  };

export const CreditUsageMeterResetDate = memo(
  ({ nextCycleStartAt, className, label }: CreditUsageMeterResetDateProps) => {
    const { daysUntilReset, dateLabel } = getCreditUsageResetDisplay({
      nextCycleStartAt,
      now: new Date(),
    });

    return (
      <div className={cn('flex w-full items-center justify-between gap-1 font-medium text-12', className)}>
        <span className="ads:text-metadata text-gray-9">{label ?? 'Limit resets in'}</span>
        <span className="ads:text-secondary text-gray-11">
          {pluralize('day', daysUntilReset, true)} · {dateLabel}
        </span>
      </div>
    );
  },
);

CreditUsageMeterResetDate.displayName = 'CreditUsageMeterResetDate';
